(function () {
  'use strict';

  var MARKERS = [
    { re: /\[KI-GEN\]/i, status: 'generated', text: 'KI-generiert' },
    { re: /\[KI\]/i,     status: 'modified',  text: 'KI-bearbeitet' }
  ];

  var ICON_SVG =
    '<svg class="ai-label__icon" viewBox="0 0 16 16" aria-hidden="true" focusable="false">' +
    '<path fill="currentColor" d="M8 1.5 9.6 5.4 13.5 7 9.6 8.6 8 12.5 6.4 8.6 2.5 7l3.9-1.6L8 1.5Z"/>' +
    '</svg>';

  function detect(alt) {
    if (!alt) return null;
    for (var i = 0; i < MARKERS.length; i++) {
      if (MARKERS[i].re.test(alt)) return MARKERS[i];
    }
    return null;
  }

  function cleanAlt(alt) {
    return alt
      .replace(/\[KI-GEN\]/gi, '')
      .replace(/\[KI\]/gi, '')
      .replace(/\s{2,}/g, ' ')
      .trim();
  }

  function ownerImgIndex(img, parent) {
    var idx = -1, count = -1;
    var kids = parent.children;
    for (var i = 0; i < kids.length; i++) {
      if (kids[i].tagName === 'IMG') {
        count++;
        if (kids[i] === img) idx = count;
      }
    }
    return { index: idx, total: count + 1 };
  }

  function labelHTML(match, ownerIndex, ownerTotal) {
    return (
      '<span class="ai-label ai-label--' + match.status + '"' +
      ' role="note" aria-label="' + match.text + '"' +
      ' data-ai-owner-index="' + ownerIndex + '"' +
      ' data-ai-owner-total="' + ownerTotal + '">' +
      ICON_SVG +
      '<span class="ai-label__text">' + match.text + '</span>' +
      '</span>'
    );
  }

  function process(img) {
    if (img.dataset.aiLabelProcessed === '1') return;
    var alt = img.getAttribute('alt');
    var match = detect(alt);
    if (!match) {
      img.dataset.aiLabelProcessed = '1';
      return;
    }

    img.setAttribute('alt', cleanAlt(alt));
    img.dataset.aiLabelProcessed = '1';

    var parent = img.parentElement;
    if (!parent) return;

    var owner = ownerImgIndex(img, parent);

    // Duplicate check for this specific owner
    var existing = parent.querySelectorAll(':scope > .ai-label[data-ai-owner-index="' + owner.index + '"]');
    if (existing.length) return;

    if (window.getComputedStyle(parent).position === 'static') {
      parent.dataset.aiLabelHost = '1';
      parent.style.position = 'relative';
    }

    parent.insertAdjacentHTML('beforeend', labelHTML(match, owner.index, owner.total));
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var imgs = scope.querySelectorAll('img:not([data-ai-label-processed="1"])');
    for (var i = 0; i < imgs.length; i++) process(imgs[i]);
  }

  function init() {
    scan(document);

    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var m = mutations[i];
          if (m.type === 'childList') {
            for (var j = 0; j < m.addedNodes.length; j++) {
              var n = m.addedNodes[j];
              if (n.nodeType !== 1) continue;
              if (n.tagName === 'IMG') process(n);
              else scan(n);
            }
          } else if (m.type === 'attributes' && m.target.tagName === 'IMG') {
            m.target.dataset.aiLabelProcessed = '';
            process(m.target);
          }
        }
      });
      mo.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['alt']
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
